@if (showGradient()) {
  <div class="card-image__gradient card-image__gradient--{{ gradientIndex() }}"></div>
} @else {
  <img [src]="imageSrc()" [alt]="alt()" />
}
